<section class="flex items-center">
    <article class="rounded w-full h-10">
      <app-input-search [placeholder]="placeholder" [searchValue]="searchValue" [width]="'full'" (submitEventEmitter)="search($event)"></app-input-search>
    </article>
    @if (searching) {
      <img [src]="images.loading" alt="loading" class="h-10 w-10" />
    } @else {
      <!-- <article class="flex border rounded w-10 h-10 items-center justify-center neutrals-grey-01-background neutrals-grey-02-border" (click)="filterOpened = !filterOpened">
        <img [src]="images.filter" alt="filter" class="p-1 m-4" [ngClass]="{ 'filterOpened': filterOpened }" />
      </article> -->
    }
  </section>
  